import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import language from "../../utils/language";
import React from "react";
import axios from "axios";
import {Link} from "@mui/material";
import { useEffect, useState } from "react";

const ContainerTop = styled("div")(({ theme }) => ({
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  minHeight: 900
}));

const PTitle = styled("div")(() => ({
  backgroundColor: "rgba(245, 255, 250, 1)",
  fontSize: 48,
  fontWeight: 700,
  color: "rgba(49, 55, 61, 1)",
  paddingTop: "32px",
  paddingBottom: "24px",
  width: "100%",
  minHeight: "200px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: '32px'
}));

const PTable = styled("div")(() => ({
  width: '80vw',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderTop: "1px solid rgba(217, 217, 217, 1)",
  borderLeft: "12px solid rgba(211, 242, 226, 1)",
  borderRight: "12px solid rgba(211, 242, 226, 1)"
}));

const PInfoOut = styled("div")(({ theme }) => ({
  padding: "16px",
  borderBottom: "1px solid rgba(217, 217, 217, 1)",
  display: 'flex',
  justifyContent: 'center'
}));

const PInfoOutDiv = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("mg")]: {
    width: "100%",
  },
  [theme.breakpoints.up("mg")]: {
    width: "60%",
  },
}));

const PInfo = styled(Link)(({ theme }) => ({
  fontSize: 36,
  fontWeight: 700,
  color: "rgba(37, 157, 95, 1) !important",
  padding: "12px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  [theme.breakpoints.down("mg")]: {
    whiteSpace: "normal",
    overflowWrap: "break-word"
  },
}));

function getLangId(cur) {
  for (let lang of language) {
    if (lang.sysLanguageCode === cur) {
      return lang.sysLanguageId;
    }
  }
  return null
}

function Top() {
  const [list, setList] = useState([]);
  const { t, i18n } = useTranslation();
  const langId = getLangId(i18n.language);
  useEffect(() => {
    const data = {
      pageNum: 1,
      pageSize: 9999999,
      queryText: "",
      sysLanguageId: langId
    };
    const url = "https://admin.pharmaciespos.com/admin/sysCourse/getCourseList";

    axios
      .post(url, data)
      .then(function (response) {
        const { status, data } = response;
        if (status === 200 && data.code === 200) {
          setList(data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }, [i18n.language]);
  return (
    <ContainerTop id="xzTop">
      <PTitle>{t("xz.x3")}</PTitle>
      <PTable>
      {
        list.map(v=> {
            return (
              <PInfoOut>
                <PInfoOutDiv>
                  <PInfo
                    href={v.downloadUrl}
                    underline="none"
                    sx={{ color: "inherit" }}
                  > 
                    {v.name}
                  </PInfo>
                </PInfoOutDiv>
              </PInfoOut>
            )
          })
        }
      </PTable>
      <PInfo></PInfo>
    </ContainerTop>
  );
}

function Web() {
  return (
    <>
      <Top />
    </>
  );
}
export default Web;
